import { classnames } from '@aibees/shared/utils';
import { forwardRef } from 'react';
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

type Props = {
  className?: string;
  id?: string;
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: (e?: React.BaseSyntheticEvent) => void;
  noValidate?: boolean;
};

export default forwardRef<HTMLFormElement, Props>(
  ({ className, children, onSubmit, methods, id, noValidate }, ref) => {
    return (
      <Form {...methods}>
        <form
          ref={ref}
          id={id}
          className={classnames('FormProvider', className)}
          onSubmit={onSubmit}
          noValidate={noValidate}
        >
          {children}
        </form>
      </Form>
    );
  }
);
